<template>
  <div id="age-risk-codes-create">
    <div class="mb-4">
      <h1>Risk Code: {{ model.RiskCodeText }}</h1>
    </div>

    <risk-code-form
        v-if="model"
        v-model="model"
        ref="form"
        pageTitle="Edit"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'risk-codes.view' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="save"
              class="my-4"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RiskCodeForm from "@/views/pages/risk-codes/RiskCodeForm";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import ViewModelMixin from '@/components/mixins/ViewModelMixin';

export default {
  name: "RiskCodeCreate",
  components: {
    RiskCodeForm
  },
  mixins: [ViewModelMixin,NotificationMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.riskCode,
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      }

      const references = [
        'RiskCodeReferenceOne_FK',
        'RiskCodeReferenceTwo_FK',
        'RiskCodeReferenceThree_FK',
        'RiskCodeReferenceFour_FK',
        'RiskCodeReferenceFive_FK',
        'RiskCodeReferenceSix_FK',
      ];

      references.forEach((ref) => {
        if (!params[ref]) {
          return true;
        }

        params[ref] = params[ref].id;
      })

      delete params.id;
      delete params.LastModifiedDateTime;

      return params;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      const params = this.getParams();

      try {
        await this.$api.riskCode.update(this.id, params);
        this.notifySuccess('Risk Code updated');
        this.$router.back();
      } catch (e) {
        this.notifyError('An error occurred');
        console.error(e)
      }
    }
  },
};
</script>

<style scoped>

</style>
